import React from "react";
import {
  imageCodes,
  titleCodes,
} from "../../template_codes/wacol/home_page_codes";

function Home() {
  return (
    <div>
      {/*                slider image                  */}
      <div class="carousel w-full">
        <div id="slide1" class="carousel-item relative w-full">
          <img src={imageCodes.banner.image} class="w-full" />
        </div>
      </div>
      {/*                slider image                  */}

      {/*                 baby section            */}
      <div className="container w-full md:w-4/5 lg:w-3/5 xl:w-3/5 2xl:w-3/5 my-20">
        <h1 className="text-center font-bold text-2xl pb-6">
          {titleCodes.baby.title}
        </h1>
        <div className="container w-full px-2">
          <div className="flex gap-x-4 md:gap-x-20">
            <div>
              <img src={imageCodes.baby1.image}></img>
              <p className="text-center text-lg py-4">0-3 လဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.baby2.image}></img>
              <p className="text-center text-lg py-4">3လ-3နှစ်ဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.baby3.image}></img>
              <p className="text-center text-lg py-4">3နှစ်-7နှစ်ဝက်</p>
            </div>
            <div>
              <img src={imageCodes.baby4.image}></img>
              <p className="text-center text-lg py-4">8နှစ်-16နှစ်ဝတ်</p>
            </div>
          </div>
        </div>
      </div>
      {/*                 end of baby section            */}

      {/*                 woman section            */}
      <div className="my-20">
        <h1 className="text-center font-bold text-2xl pb-6">
          {titleCodes.woman.title}
        </h1>
        <div className="container w-full md:w-3/5 lg:w-3/5 xl:w-2/4 2xl:w-2/5 py-8">
          <div className="container w-full px-2">
            <div className="flex gap-x-4 md:gap-x-20">
              <div>
                <img src={imageCodes.lady1.image}></img>
                <p className="text-center text-lg py-4">ဂါဝန်</p>
              </div>
              <div>
                <img src={imageCodes.lady2.image}></img>
                <p className="text-center text-lg py-4">အင်္ကျီ</p>
              </div>
              <div>
                <img src={imageCodes.lady3.image}></img>
                <p className="text-center text-lg py-4">ဘောင်းဘီ/စကတ်</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container w-full md:w-3/5 lg:w-3/5 xl:w-2/4 2xl:w-2/5 py-8">
          <div className="container w-full px-2">
            <div className="flex gap-x-4 md:gap-x-20">
              <div>
                <img src={imageCodes.lady5.image}></img>
                <p className="text-center text-lg py-4">အပေါ်ဝတ်</p>
              </div>
              <div>
                <img src={imageCodes.lady4.image}></img>
                <p className="text-center text-lg py-4">အတွင်းခံ</p>
              </div>
              <div>
                <img src={imageCodes.lady6.image}></img>
                <p className="text-center text-lg py-4">ညဝတ်</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*                 end of woman section            */}

      {/*                 man section            */}
      <div className="container w-full md:w-full lg:w-5/6 xl:w-5/6 2xl:w-5/6 my-20">
        <h1 className="text-center font-bold text-2xl pb-6">
          {titleCodes.man.title}
        </h1>
        <div className="container w-full px-2">
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-x-8">
            <div>
              <img src={imageCodes.man1.image}></img>
              <p className="text-center text-lg py-4">အင်္ကျီ</p>
            </div>
            <div>
              <img src={imageCodes.man2.image}></img>
              <p className="text-center text-lg py-4">ဘောင်းဘီ</p>
            </div>
            <div>
              <img src={imageCodes.man3.image}></img>
              <p className="text-center text-lg py-4">အပေါ်ဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.man4.image}></img>
              <p className="text-center text-lg py-4">ညဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.man5.image}></img>
              <p className="text-center text-lg py-4">အတွင်းခံ</p>
            </div>
          </div>
        </div>
      </div>
      {/*                 end of man section            */}

      {/*                 other section            */}
      <div className="container w-full md:w-full lg:w-5/6 xl:w-5/6 2xl:w-5/6 my-20">
        <h1 className="text-center font-bold text-2xl pb-6">
          {titleCodes.other.title}
        </h1>
        <div className="container w-full px-2">
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-x-8">
            <div>
              <img src={imageCodes.other1.image}></img>
              <p className="text-center text-lg py-4">ဦးထုပ်</p>
            </div>
            <div>
              <img src={imageCodes.other2.image}></img>
              <p className="text-center text-lg py-4">ဆံပင်အသုံးအဆောင်များ</p>
            </div>
            <div>
              <img src={imageCodes.other3.image}></img>
              <p className="text-center text-lg py-4">ခြေအိတ်</p>
            </div>
            <div>
              <img src={imageCodes.other3.image}></img>
              <p className="text-center text-lg py-4">ခါးပတ်</p>
            </div>
            <div>
              <img src={imageCodes.other2.image}></img>
              <p className="text-center text-lg py-4">ပုဝါ</p>
            </div>
          </div>
        </div>
      </div>
      {/*                 end of other section            */}

      {/*                 man section            */}
      <div className="container w-full md:w-full lg:w-5/6 xl:w-5/6 2xl:w-5/6 my-20">
        <h1 className="text-center font-bold text-2xl pb-6">
          {titleCodes.bestSeller.title}
        </h1>
        <div className="container w-full px-2">
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-x-8">
            <div>
              <img src={imageCodes.man1.image}></img>
              <p className="text-center text-lg py-4">အင်္ကျီ</p>
            </div>
            <div>
              <img src={imageCodes.man2.image}></img>
              <p className="text-center text-lg py-4">ဘောင်းဘီ</p>
            </div>
            <div>
              <img src={imageCodes.man3.image}></img>
              <p className="text-center text-lg py-4">အပေါ်ဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.man4.image}></img>
              <p className="text-center text-lg py-4">ညဝတ်</p>
            </div>
            <div>
              <img src={imageCodes.man5.image}></img>
              <p className="text-center text-lg py-4">အတွင်းခံ</p>
            </div>
          </div>
        </div>
      </div>
      {/*                 end of man section            */}

      {/*                 shipping section            */}
      <div className="my-20">
        <h1 className="text-center font-bold text-2xl">
          {titleCodes.shipping.title}
        </h1>
      </div>
      {/*                 end of shipping section            */}

      {/*                 contact section            */}
      <div className="my-20">
        <h1 className="text-center font-bold text-2xl">
          {titleCodes.contact.title}
        </h1>
        <p className="text-center pt-5">
          <ul className="list-none">1</ul>
          <ul className="list-none">2</ul>
        </p>
        <p className="text-center pt-5">2</p>
      </div>
      {/*                 end of contact section            */}

      {/*                 about section            */}
      <div className="my-20">
        <h1 className="text-center font-bold text-2xl">
          {titleCodes.about.title}
        </h1>
        <p className="text-center pt-5">
          Wacol ဝါကိုးလ်စတိုးအထည်ဆိုင် was established in 1994. We are
          delivering our clothing through out Myan
        </p>
      </div>
      {/*                 end of about section            */}
    </div>
  );
}

export default Home;
